import {
    Component,
    OnInit,
    Injector,
    ViewEncapsulation,
    ViewChild,
} from "@angular/core";
import { AbpSessionService } from "@abp/session/abp-session.service";
import { AppSessionService } from "@shared/common/session/app-session.service";
import { AbpMultiTenancyService } from "@abp/multi-tenancy/abp-multi-tenancy.service";
import {
    ProfileServiceProxy,
    UserLinkServiceProxy,
    UserServiceProxy,
    LinkedUserDto,
    ChangeUserLanguageDto,
    TenantLoginInfoDto,
    GetCurrentLoginInformationsOutput,
    SessionServiceProxy,
    ChangeUserCalenderDto,
    TenantSettingsServiceProxy,
    TenantListDto,
} from "@shared/service-proxies/service-proxies";
import { AppComponentBase } from "@shared/common/app-component-base";

import { LoginAttemptsModalComponent } from "./login-attempts-modal.component";
import { LinkedAccountsModalComponent } from "./linked-accounts-modal.component";
import { ChangePasswordModalComponent } from "./profile/change-password-modal.component";
import { ChangeProfilePictureModalComponent } from "./profile/change-profile-picture-modal.component";
import { MySettingsModalComponent } from "./profile/my-settings-modal.component";
import { AppAuthService } from "@app/shared/common/auth/app-auth.service";
import { ImpersonationService } from "@app/admin/users/impersonation.service";
import { LinkedAccountService } from "@app/shared/layout/linked-account.service";
import { NotificationSettingsModalComponent } from "@app/shared/layout/notifications/notification-settings-modal.component";
import { UserNotificationHelper } from "@app/shared/layout/notifications/UserNotificationHelper";
import { AppConsts } from "@shared/AppConsts";
import { SubscriptionStartType, EditionPaymentType } from "@shared/AppEnums";

import * as _ from "lodash";
import * as moment from "moment";
import { UtilsService } from "@abp/utils/utils.service";

@Component({
    templateUrl: "./header.component.html",
    selector: "header-bar",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent extends AppComponentBase implements OnInit {
    @ViewChild("notificationSettingsModal")
    notificationSettingsModal: NotificationSettingsModalComponent;

    @ViewChild("loginAttemptsModal")
    loginAttemptsModal: LoginAttemptsModalComponent;
    @ViewChild("linkedAccountsModal")
    linkedAccountsModal: LinkedAccountsModalComponent;
    @ViewChild("changePasswordModal")
    changePasswordModal: ChangePasswordModalComponent;
    @ViewChild("changeProfilePictureModal")
    changeProfilePictureModal: ChangeProfilePictureModalComponent;
    @ViewChild("mySettingsModal") mySettingsModal: MySettingsModalComponent;

    languages: abp.localization.ILanguageInfo[];
    currentLanguage: abp.localization.ILanguageInfo;
    isImpersonatedLogin = false;
    currentCalenderEn = false;
    currentCalender: any;
    shownLoginNameTitle = "";
    shownLoginName = "";
    profilePicture = "/assets/common/images/default-profile-picture.png";
    recentlyLinkedUsers: LinkedUserDto[];
    unreadChatMessageCount = 0;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    chatConnected = false;
    imgSrc: string;
    tenant: TenantLoginInfoDto = new TenantLoginInfoDto();
    subscriptionStartType = SubscriptionStartType;
    editionPaymentType: typeof EditionPaymentType = EditionPaymentType;
    isParentTenantManage: boolean = false;

    constructor(
        injector: Injector,
        private _abpSessionService: AbpSessionService,
        private _abpMultiTenancyService: AbpMultiTenancyService,
        private _profileServiceProxy: ProfileServiceProxy,
        private _userLinkServiceProxy: UserLinkServiceProxy,
        private _tenantSettingsService: TenantSettingsServiceProxy,
        private _userServiceProxy: UserServiceProxy,
        private _authService: AppAuthService,
        private _impersonationService: ImpersonationService,
        private _linkedAccountService: LinkedAccountService,
        private _userNotificationHelper: UserNotificationHelper,
        private _sessionService: SessionServiceProxy,
        private _appSessionService: AppSessionService,
        private _utilService: UtilsService
    ) {
        super(injector);
        this.appSession = injector.get(AppSessionService);
    }

    get multiTenancySideIsTenant(): boolean {
        return this._abpSessionService.tenantId > 0;
    }

    ngOnInit() {
        this._userNotificationHelper.settingsModal =
            this.notificationSettingsModal;

        this.languages = _.filter(
            this.localization.languages,
            (l) => (<any>l).isDisabled === false
        );
        this.currentLanguage = this.localization.currentLanguage;
        this.currentCalenderEn =
            this.currentLanguage.name == "en" ? true : false;
        this.isImpersonatedLogin =
            this._abpSessionService.impersonatorUserId > 0;
        this._sessionService.getCurrentCalender().subscribe((result) => {
            this.currentCalender =
                result.currentCalender == "en"
                    ? this.l("GregorianCalendar")
                    : this.l("HijriCalender");
        });
        if (this.currentCalenderEn) {
            this.currentCalender = this.l("GregorianCalendar");
        }
        this._tenantSettingsService.getLogo().subscribe((res) => {
            this.imgSrc = res.logo;
        });
        this.shownLoginNameTitle = this.isImpersonatedLogin
            ? this.l("YouCanBackToYourAccount")
            : "";
        this.getCurrentLoginInformations();
        this.getProfilePicture();
        this.getRecentlyLinkedUsers();

        this.registerToEvents();

        // GET TENANT INFORMATION
        var tenantInfo = this._utilService.getCookieValue(
            AppConsts.appSessionItems.tenantInfo
        );
        if (tenantInfo) {
            var tenant = JSON.parse(tenantInfo) as TenantListDto;
            if (tenant) {
                var currentIsParentTenant = this._utilService.getCookieValue(
                    AppConsts.appSessionItems.isParentTenantManage
                );
                this.isParentTenantManage =
                    tenant.isParent && parseInt(currentIsParentTenant) == 1;
            }
        }
    }

    registerToEvents() {
        abp.event.on("profilePictureChanged", () => {
            this.getProfilePicture();
        });

        abp.event.on("app.chat.unreadMessageCountChanged", (messageCount) => {
            this.unreadChatMessageCount = messageCount;
        });

        abp.event.on("app.chat.connected", () => {
            this.chatConnected = true;
        });
    }

    changeLanguage(languageName: string): void {
        const input = new ChangeUserLanguageDto();
        input.languageName = languageName;

        this._profileServiceProxy.changeLanguage(input).subscribe(() => {
            abp.utils.setCookieValue(
                "Abp.Localization.CultureName",
                languageName,
                new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
                abp.appPath
            );

            window.location.reload();
        });
    }
    ChangeCalender(CalendereName: string): void {
        const input = new ChangeUserCalenderDto();
        input.calenderName = CalendereName;

        this._profileServiceProxy.changeCalendarAsync(input).subscribe(() => {
            // abp.utils.setCookieValue(
            //     'Abp.Localization.CultureName',
            //     CalendereName,
            //     new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
            //     abp.appPath
            // );
            this.currentCalender =
                input.calenderName == "en"
                    ? this.l("GregorianCalendar")
                    : this.l("HijriCalender");
            window.location.reload();
        });
    }

    getCurrentLoginInformations(): void {
        this.shownLoginName = this.appSession.getShownLoginName();
        this._sessionService
            .getCurrentLoginInformations()
            .subscribe((result: GetCurrentLoginInformationsOutput) => {
                this.tenant = result.tenant;
            });
    }

    getShownUserName(linkedUser: LinkedUserDto): string {
        if (!this._abpMultiTenancyService.isEnabled) {
            return linkedUser.username;
        }

        return (
            (linkedUser.tenantId ? linkedUser.tenancyName : ".") +
            "\\" +
            linkedUser.username
        );
    }

    getProfilePicture(): void {
        this._profileServiceProxy.getProfilePicture().subscribe((result) => {
            if (result && result.profilePicture) {
                this.profilePicture =
                    "data:image/jpeg;base64," + result.profilePicture;
            }
        });
    }

    getRecentlyLinkedUsers(): void {
        this._userLinkServiceProxy
            .getRecentlyUsedLinkedUsers()
            .subscribe((result) => {
                this.recentlyLinkedUsers = result.items;
            });
    }

    showLoginAttempts(): void {
        this.loginAttemptsModal.show();
    }

    showLinkedAccounts(): void {
        this.linkedAccountsModal.show();
    }

    changePassword(): void {
        this.changePasswordModal.show();
    }

    changeProfilePicture(): void {
        this.changeProfilePictureModal.show();
    }

    changeMySettings(): void {
        this.mySettingsModal.show();
    }

    logout(): void {
        this._authService.logout();
    }

    onMySettingsModalSaved(): void {
        this.shownLoginName = this.appSession.getShownLoginName();
    }

    backToMyAccount(): void {
        this._impersonationService.backToImpersonator();
    }

    switchToLinkedUser(linkedUser: LinkedUserDto): void {
        this._linkedAccountService.switchToAccount(
            linkedUser.id,
            linkedUser.tenantId
        );
    }

    get chatEnabled(): boolean {
        return (
            this.appSession.application.features["SignalR"] &&
            (!this._abpSessionService.tenantId ||
                this.feature.isEnabled("App.ChatFeature"))
        );
    }

    subscriptionStatusBarVisible(): boolean {
        return (
            this._appSessionService.tenantId > 0 &&
            this.subscriptionIsExpiringSoon()
        );
    }

    subscriptionIsExpiringSoon(): boolean {
        if (this._appSessionService.tenant.subscriptionEndDateUtc) return true;

        return false;
    }

    getSubscriptionExpiringDayCount(): number {
        if (!this._appSessionService.tenant.subscriptionEndDateUtc) {
            return 0;
        }

        return Math.round(
            moment(
                this._appSessionService.tenant.subscriptionDateString,
                "MM/DD/YYYY"
            ).diff(moment().utc(), "days", true)
        );
    }

    getTrialSubscriptionNotification(): string {
        return abp.utils.formatString(
            this.l("TrialSubscriptionNotification"),
            "<strong>" +
                this._appSessionService.tenant.edition.displayName +
                "</strong>",
            "<a href='/account/buy?editionId=" +
                this._appSessionService.tenant.edition.id +
                "&editionPaymentType=" +
                this.editionPaymentType.BuyNow +
                "'>" +
                this.l("ClickHere") +
                "</a>"
        );
    }

    getExpireNotification(localizationKey: string): string {
        return abp.utils.formatString(
            this.l(localizationKey),
            this.getSubscriptionExpiringDayCount()
        );
    }
    HandleBackToMyStore(): void {
        this._impersonationService.backToImpersonator();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header.component.ts